{
  "auth": {
    "requiredTitle": "Sign in through Telegram",
    "requiredBody": "Open this app from your Telegram bot to continue."
  },
  "navigation": {
    "back": "Back",
    "home": "Home",
    "profile": "Profile"
  },
  "dashboard": {
    "title": "Services",
    "subtitle": "Choose a service to continue",
    "loading": "Loading services...",
    "noServices": "No services are enabled for this account.",
    "queryServiceUnavailable": "The requested service is not available in this account.",
    "communityLinks": "Community links"
  },
  "services": {
    "ecommerce": {
      "title": "Shop",
      "description": "Browse products, place orders, and track delivery."
    },
    "marketplace": {
      "title": "Marketplace",
      "description": "Browse local classifieds, publish ads, and chat anonymously."
    },
    "events": {
      "title": "Events",
      "description": "Discover upcoming events and venue navigation details."
    },
    "digitalMedia": {
      "title": "Digital Media Shop",
      "description": "Courses, audio editions, and subscription-based learning content."
    },
    "healthBeauty": {
      "title": "Health & Beauty",
      "description": "Clinics, salons and specialists — book an appointment"
    },
    "education": {
      "title": "Education",
      "description": "Discover institutions, tutors, and trusted community reviews."
    },
    "restaurants": {
      "title": "Restaurants",
      "description": "Discover restaurants, menus and table requests."
    }
  },
  "staff": {
    "title": "Staff Tools",
    "badge": "Management",
    "ecommerce": {
      "manager": {
        "title": "Order Management",
        "description": "Manage orders and deliveries"
      }
    },
    "marketplace": {
      "moderator": {
        "title": "Ad Moderation",
        "description": "Review and moderate ads"
      }
    },
    "events": {
      "manager": {
        "title": "Events Manager",
        "description": "Manage your events and locations"
      }
    },
    "digitalMedia": {
      "manager": {
        "title": "Digital Media Manager",
        "description": "Manage courses and lesson content"
      }
    },
    "healthBeauty": {
      "manager": {
        "title": "Clinic Desk",
        "description": "Manage today's appointments"
      }
    },
    "education": {
      "manager": {
        "title": "Education Manager",
        "description": "Manage education leads and reviews"
      }
    },
    "restaurants": {
      "manager": {
        "title": "Restaurant Manager",
        "description": "Manage menu, table requests and reviews"
      }
    }
  },
  "errors": {
    "loadServices": "Unable to load services. Please try again."
  },
  "service": {
    "unavailable": "This service is not available in this account."
  },
  "search": {
    "placeholder": "Search the ecosystem...",
    "results": "Search results",
    "failed": "Could not load discovery results. Please try again.",
    "empty": "No matching items"
  },
  "trending": {
    "title": "Trending",
    "swipe": "Swipe →",
    "item1": {
      "badge": "Important",
      "title": "Marketplace rules updates"
    },
    "item2": {
      "badge": "Events",
      "title": "IT meetup this Sunday: registration is open"
    }
  },
  "categories": {
    "title": "Categories",
    "marketplace": "Marketplace",
    "petZone": "Pet zone",
    "services": "Services",
    "eventsBot": "Events bot",
    "shops": "Shops",
    "digitalMedia": "Digital media",
    "healthBeauty": "Health & Beauty",
    "education": "Education",
    "restaurants": "Restaurants",
    "gifts": "Gifts",
    "news": "News",
    "rent": "Rent"
  },
  "partnership": {
    "title": "Become a partner",
    "subtitle": "List your business in our ecosystem today",
    "action": "Learn more"
  },
  "footer": {
    "home": "Home",
    "search": "Search",
    "favorites": "Favorites",
    "profile": "Profile"
  },
  "profile": {
    "description": "Your account in this community.",
    "guest": "Telegram user"
  }
}
